import { BaseTelemetryService } from './telemetry';
import { makeDebugger } from '@lib';

class ConsoleService implements BaseTelemetryService {
  public name: string = 'console';
  private debug = makeDebugger('telemetry');

  public init() {
    return Promise.resolve('console');
  }

  public sendEvent(event: string) {
    this.debug(event);
  }

  public destroy() {
    return;
  }
}

export const consoleService = new ConsoleService();
